import { useTranslation } from 'react-i18next'
import { LargeDialog } from 'ui/src/components/Dialog/LargeDialog'
import { Text } from 'ui/src/components/Text/Text'
import { yStack } from 'ui/src/patterns/stack'
import { SignUpForm } from '../SignUpForm/SignUpForm'
import { dialogContent } from './SignUpDialog.css'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function SignUpDialog({ open, onOpenChange }: Props) {
  const { t } = useTranslation(['vintageShop', 'common'])

  return (
    <LargeDialog.Root open={open} onOpenChange={onOpenChange}>
      <LargeDialog.Content className={dialogContent}>
        <LargeDialog.CloseIconButton aria-label={t('common:DIALOG_CLOSE')} />
        <div className={yStack({ gap: 'md' })}>
          <header>
            <LargeDialog.Heading>{t('VINTAGE_SHOP_SIGN_UP_DIALOG_HEADING')}</LargeDialog.Heading>
            <Text color="textSecondary" size={{ _: 'md', md: 'xl' }}>
              {t('VINTAGE_SHOP_SIGN_UP_DIALOG_BODY')}
            </Text>
          </header>

          <SignUpForm />
        </div>
      </LargeDialog.Content>
    </LargeDialog.Root>
  )
}
